/**
 * Contact modal
 */

var component_contact_modal = function(args) {

  // setup args
  var modal = args.modal

  // validate
  if (!modal) {
    console.log('Invalid contact modal');
    return;
  }

  /**
   * Init
   */
  function init() {

    // Instantiate a new A11yDialog module
    let dialog = new A11yDialog(modal);

    // show
    dialog.on('show', (dialogEl, event) => dialogEl.classList.add('dialog-visible'));

    // hide
    dialog.on('hide', (dialogEl, event) => dialogEl.classList.remove('dialog-visible'));

  }

  init();

  // make the call chainable
  return this;

};

